var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlobalLine = function SvgGlobalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 1 1 0 16.666ZM8.092 16.39a14.917 14.917 0 0 1-1.403-5.556H3.385a6.673 6.673 0 0 0 4.707 5.556Zm.266-5.556A13.262 13.262 0 0 0 10 16.46a13.254 13.254 0 0 0 1.642-5.627H8.358Zm8.257 0h-3.304a14.917 14.917 0 0 1-1.403 5.556 6.673 6.673 0 0 0 4.707-5.556ZM3.385 9.167h3.304c.104-1.926.58-3.812 1.403-5.556a6.673 6.673 0 0 0-4.707 5.556Zm4.974 0h3.282A13.254 13.254 0 0 0 10 3.54a13.254 13.254 0 0 0-1.642 5.627h.001Zm3.55-5.556a14.917 14.917 0 0 1 1.402 5.556h3.304a6.673 6.673 0 0 0-4.707-5.556Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgGlobalLine;